import { queryRawLocalStorage } from '../../../common/utils';
export const isNotificationsDisable = () => {
  const isDisabled = queryRawLocalStorage('NOTIFICATIONS_DISABLE') === 'true';
  return isDisabled;
};